import { ArrowForward } from '@mui/icons-material';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import {
  Box,
  Button,
  Chip,
  TableCell,
  Tooltip,
  Typography,
} from '@mui/material';
import getSymbolFromCurrency from 'currency-symbol-map';
import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import { Link, useNavigate } from 'react-router-dom';
import { getCurrencySymbol } from '../../../project/ticket/ActionPane/Orders/Retractions/FeesCalculations';
import BrandIcon from '../../../utils/common/BrandIcon';

export const RefCell = ({ data }) => {
  const navigate = useNavigate();
  const [tooltip, setTooltip] = useState();
  const handleNavigateToTicket = (navigateTo) => {
    navigate(`/project/${navigateTo}/tickets/`);
  };

  const handleCopy = (value) => {
    if (value) {
      navigator.clipboard.writeText(value);
      setTooltip('Texte copié !');
      setTimeout(() => {
        setTooltip(null);
      }, 2000);
    }
  };

  return (
    <TableCell
      sx={{
        border: 1,
      }}
      align="center"
      key={data?._id}
    >
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-evenly',
        }}
      >
        {data?.contact_store_brand?.name ? (
          <BrandIcon
            brand={data?.contact_store_brand?.name}
            type={data?.contact_store_contactType?.codeBO}
            sx={{ fontSize: 40, maxHeight: 40, maxWidth: 40 }}
          />
        ) : (
          <div style={{ width: 40 }} />
        )}
        <Tooltip title="Naviguer vers le projet">
          <Button
            variant="outlined"
            color="primary"
            size="small"
            startIcon={<ArrowForward fontSize="small" />}
            onClick={() => handleNavigateToTicket(data?.project)}
            disabled={!data?.project}
            sx={{
              marginLeft: 1,
              whiteSpace: 'nowrap',
              minWidth: 'auto',
            }}
          >
            {data.reference}
          </Button>
        </Tooltip>
        <Tooltip title={tooltip || 'Copier la référence'}>
          <Button
            variant="outlined"
            color="primary"
            size="small"
            sx={{ marginLeft: 1 }}
            onClick={() => handleCopy(data?.reference)}
          >
            <ContentCopyIcon fontSize="small" />
          </Button>
        </Tooltip>
      </Box>
    </TableCell>
  );
};

export const DateCell = ({ data, props }) => {
  const date = data?.[props];

  return (
    <TableCell sx={{ border: 1 }} align="center" key={data?._id}>
      {date ? (
        new Date(date).toLocaleString('fr-FR', {
          year: 'numeric',
          month: '2-digit',
          day: '2-digit',
        })
      ) : (
        <Typography
          sx={{
            padding: 1,
            fontSize: 13,
          }}
        >
          Date non disponible
        </Typography>
      )}
    </TableCell>
  );
};

export const ContactCell = ({ data, props }) => {
  const [tooltip, setTooltip] = useState();

  const handleCopy = (value) => {
    if (value) {
      navigator.clipboard.writeText(value);
      setTooltip('Texte copié !');
      setTimeout(() => {
        setTooltip(null);
      }, 2000);
    }
  };
  return (
    <TableCell sx={{ border: 1 }} align="center" key={data?._id}>
      <Tooltip title={tooltip || "Cliquez pour copier l'email du client"} arrow>
        <Link
          onClick={() => handleCopy(data[props].email)}
          sx={{ cursor: 'copy' }}
        >
          {data[props]?.firstName} {data[props]?.lastName}
        </Link>
      </Tooltip>
    </TableCell>
  );
};

export const PriceCell = ({ data, props }) => {
  const currency = useSelector((state) => state.static.currency);
  const type = useSelector((state) => state.static.orderTypes);
  const currencyDetails = currency?.find(
    ({ _id }) => _id.toString() === data?.currency
  );
  const typeDetails = type?.find(
    ({ _id }) =>
      _id.toString() === data?.type?.toString() ||
      _id.toString() === data?.type?._id?.toString()
  );
  const price = data[props] === 0 ? '0.00' : data[props];
  if (typeDetails?.code === 'ORDER_SAV') {
    return (
      <TableCell
        sx={{ border: 1 }}
        align={data?.isPayable ? 'left' : 'center'}
        key={data?._id}
      >
        <Chip
          size="small"
          sx={{ marginRight: 1 }}
          label={data?.isPayable ? 'SAV Payant' : 'SAV Gratuit'}
          color={data?.isPayable ? 'warning' : 'success'}
          variant="outlined"
        />
        {data?.isPayable && (
          <>
            {price || 'N/A'}
            {price ? getSymbolFromCurrency(currencyDetails?.code) : ''}
          </>
        )}
      </TableCell>
    );
  } else {
    return (
      <TableCell sx={{ border: 1 }} align="center" key={data?._id}>
        {price || 'N/A'}
        {price ? getSymbolFromCurrency(currencyDetails?.code) : ''}
      </TableCell>
    );
  }
};

export const StatusCell = ({ data, props }) => {
  const status = data[props];

  return (
    <TableCell sx={{ border: 1 }} align="center" key={data?._id}>
      <Typography
        sx={{
          padding: 1,
          fontSize: 13,
        }}
      >
        {status?.name || "Pas d'informations de statut"}
      </Typography>
    </TableCell>
  );
};

export const ReasonCell = ({ data, props }) => {
  return (
    <TableCell sx={{ border: 1 }} align="center" key={data?._id}>
      <Typography
        sx={{
          padding: 1,
          fontSize: 13,
        }}
      >
        {data?.[props]?.reason?.name || 'Motif non disponible'}
      </Typography>
    </TableCell>
  );
};

export const RefundCell = ({ data, props }) => {
  const currency = useSelector((state) => state.static.currency);
  const currencyDetails = currency?.find(
    ({ _id }) => _id.toString() === data?.currency
  );
  return (
    <TableCell sx={{ border: 1 }} align="center" key={data?._id}>
      <Typography
        sx={{
          padding: 1,
          fontSize: 13,
        }}
      >
        {data?.[props]?.refund
          ? data?.[props]?.refund?.amountToRefund
          : ' --- '}
        {getCurrencySymbol(currencyDetails?.code)}
      </Typography>
    </TableCell>
  );
};

export const ActionCell = ({ data, props, children }) => {
  const [isOpen, setIsOpen] = useState(!props.isDisplayed);
  return (
    <TableCell sx={{ border: 1 }} align="center" key={data?._id}>
      <Button
        variant="outlined"
        color="primary"
        size="small"
        startIcon={props.icon}
        onClick={() => setIsOpen(true)}
        sx={{
          marginLeft: 1,
          whiteSpace: 'nowrap',
          minWidth: 'auto',
        }}
        disabled={props.isDisabled}
      >
        {props.textContent}
      </Button>
      {children &&
        isOpen &&
        React.cloneElement(children, {
          isOpen,
          onClose: () => setIsOpen(false),
          data: data,
          ...props,
        })}
    </TableCell>
  );
};
